import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Descriptions, Divider, Space, Tag, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import AirwayBillHistory from './AirwayBillHistory';
import './AirwayBillHistory.css';

const statusColors = {
  'SHIPPING': 'processing',
  'ARRIVED': 'warning',
  'INSPECTION_NEEDED': 'error',
  'INSPECTED': 'warning',
  'DELIVERING': 'processing',
  'DELIVERED': 'success',
  'RELEASED': 'success'
};

const statusLabels = {
  'DUPLICATE': '重复订单',
  'SHIPPING': '运输中',
  'PENDING_REVIEW': '未审单',
  'PENDING_CUSTOMS': '待清关',
  'PICKED_UP': '已提货未过机',
  'INSPECTED_PENDING': '已出查验未放行',
  'RELEASED': '已放行'
};

const AirwayBillDetail = () => {
  const [loading, setLoading] = useState(true);
  const [airwayBill, setAirwayBill] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchAirwayBill = async () => {
      try {
        const response = await fetch(`/api/airway-bills/${id}/`);
        const data = await response.json();
        setAirwayBill(data);
      } catch (error) {
        console.error('Error fetching airway bill:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAirwayBill();
  }, [id]);

  if (loading) {
    return <Spin size="large" />;
  }

  if (!airwayBill) {
    return <div>空运单不存在</div>;
  }

  const formatDate = (date) => {
    return date ? moment(date).format('YYYY-MM-DD') : '-';
  };

  const formatDateTime = (datetime) => {
    return datetime ? moment(datetime).format('YYYY-MM-DD HH:mm:ss') : '-';
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Card title="空运单详情">
        <Descriptions bordered>
          <Descriptions.Item label="空运单号">{airwayBill.airway_bill_number}</Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag color={statusColors[airwayBill.status]}>
              {statusLabels[airwayBill.status]}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="落地口岸">{airwayBill.port_of_entry}</Descriptions.Item>
          
          <Descriptions.Item label="提单件数">{airwayBill.bill_count}</Descriptions.Item>
          <Descriptions.Item label="提单重量">{airwayBill.bill_weight} KG</Descriptions.Item>
          <Descriptions.Item label="包裹数量">{airwayBill.package_count}</Descriptions.Item>
          
          <Descriptions.Item label="短装数量">{airwayBill.under_packed}</Descriptions.Item>
          <Descriptions.Item label="出税包裹数量">{airwayBill.taxed_package_count}</Descriptions.Item>
          <Descriptions.Item label="平均税金">{airwayBill.average_tax}</Descriptions.Item>
        </Descriptions>

        <Divider orientation="left">时间信息</Divider>
        <Descriptions bordered>
          <Descriptions.Item label="起飞时间">{formatDate(airwayBill.departure_date)}</Descriptions.Item>
          <Descriptions.Item label="实际到港时间">{formatDate(airwayBill.arrival_date)}</Descriptions.Item>
          <Descriptions.Item label="资料发送时间">{formatDateTime(airwayBill.document_send_time)}</Descriptions.Item>
          
          <Descriptions.Item label="机场提货时间">{formatDateTime(airwayBill.airport_pickup_time)}</Descriptions.Item>
          <Descriptions.Item label="审单时间">{formatDateTime(airwayBill.document_review_time)}</Descriptions.Item>
          <Descriptions.Item label="过机时间">{formatDateTime(airwayBill.processing_time)}</Descriptions.Item>
          
          <Descriptions.Item label="清关放行时间">{formatDateTime(airwayBill.customs_clearance_time)}</Descriptions.Item>
          <Descriptions.Item label="快递揽件时间">{formatDateTime(airwayBill.courier_pickup_time)}</Descriptions.Item>
        </Descriptions>

        <Divider orientation="left">费用信息</Divider>
        <Descriptions bordered>
          <Descriptions.Item label="快递费用">{airwayBill.courier_fee}</Descriptions.Item>
          <Descriptions.Item label="总税金">{airwayBill.total_tax}</Descriptions.Item>
          <Descriptions.Item label="补税金额">{airwayBill.additional_tax}</Descriptions.Item>
        </Descriptions>

        {airwayBill.additional_tax_notes && (
          <>
            <Divider orientation="left">补税备注</Divider>
            <p>{airwayBill.additional_tax_notes}</p>
          </>
        )}
      </Card>

      <AirwayBillHistory history={airwayBill.history} />
    </Space>
  );
};

export default AirwayBillDetail;
